import TextField, { TextFieldProps } from '@mui/material/TextField';
import { FocusEvent } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { useTranslation } from '../../modules/translation/TranslationContext';
import Field from './Field';

export type RFFTextFieldProps = TextFieldProps & {
  name: string;
  label?: string;
  fullWidth?: boolean;
  initialValue?: any;
  min?: string;
  max?: string;
  testId?: string;
};

const handleOnBlur = (
  event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
  callbacks: (Function | undefined)[],
) => {
  for (let index = 0; index < callbacks.length; index += 1) {
    const callback = callbacks[index];
    if (callback) {
      callback(event);
    }
  }
};
/**
 * @deprecated React Final Form has been deprecated in the system.
 * Components based on RFF are no longer supported.
 * Please use <TextField /> or other updated alternatives.
 */
const RFFTextField = ({
  fullWidth,
  label = '',
  name,
  initialValue,
  min,
  max,
  testId,
  ...others
}: RFFTextFieldProps) => {
  const { translate } = useTranslation();

  return (
    <Field name={name} initialValue={initialValue}>
      {({
        input,
        meta,
        ...props
      }: FieldRenderProps<string, HTMLInputElement | HTMLTextAreaElement>) => (
        <TextField
          variant="standard"
          {...input}
          {...props}
          {...others}
          fullWidth={fullWidth}
          label={label}
          error={others.error || (meta.touched && !!meta.error)}
          helperText={others.helperText || (meta.touched && meta.error && translate(meta.error))}
          onBlur={(event) => handleOnBlur(event, [input.onBlur, others.onBlur])}
          slotProps={{
            htmlInput: { min, max, 'test-id': testId },
          }}
        />
      )}
    </Field>
  );
};

export default RFFTextField;
